<div class="container-grid" [ngStyle]="containerStyles" style="margin-top: 4px;">
  <div class="subtitle">
    <div class="d-flex">
      <h2 class="title mb-3">{{ texts.title }}</h2>
      <i class="bi bi-plus-circle" (click)="addLocation()" *ngIf="movimiento !== 'detalle'"></i>
    </div>

    <p class="mb-0 amount-to-be-allocated">{{ texts.tonsToBeAssigned }}: {{ amountsToBeAllocated.tons | number : '1.3-3' }}({{ amountsToBeAllocated.tonsPercentage | number : '1.2-2' }}%)</p>
    <p class="mb-0 amount-to-be-allocated">{{ texts.piecesToBeAssigned }}: {{ amountsToBeAllocated.pieces }}({{ amountsToBeAllocated.piecesPercentage | number : '1.2-2' }}%)</p>
  </div>
  <ng-container [formGroup]="locationForm">
    <ng-container formArrayName="location_list">
      <ng-container *ngFor="let location of locationArray['controls']; let i=index" [formGroupName]="i">
        <div class="grid-first">
          <label for="ubicacion-{{ i }}" class="form-label">{{ texts.locationLabel }}</label>
          <select
              id="ubicacion-{{ i }}"
              class="form-control"
              formControlName="location_id"
              (change)="changeLocation()"
            >
            <option value="">-- Seleccione la Ubicación --</option>
            <option *ngFor="let location of locationsFiltered" [value]="location.id" [disabled]="location.disabled">
              {{ location.description }}
            </option>
          </select>
          <span class="form-text text-danger" *ngIf="isValidArray(i, 'location_id')">
            Selecciona la ubicación
          </span>
        </div>
        <div class="d-flex gap-3" *ngIf="isOutput">
          <div class="w-100">
            <label for="locationTonsPerYard-{{ i }}" class="form-label">Tonelaje de la ubicación*</label>
            <input
              type="text"
              id="locationTonsPerYard-{{ i }}"
              class="form-control"
              formControlName="location_tonnage"
            >
          </div>
          <div class="w-100">
            <label for="locationPiecesPerYard-{{ i }}" class="form-label">Piezas de la ubicación*</label>
            <input
              type="text"
              id="locationPiecesPerYard-{{ i }}"
              class="form-control"
              formControlName="location_pieces"
            >
          </div>
        </div>
        <div>
          <label for="tonsPerYard-{{ i }}" class="form-label">{{ texts.tonnageLabel }}</label>
          <input
            type="text"
            id="tonsPerYard-{{ i }}"
            class="form-control"
            formControlName="tonnage"
            maxlength="15"
            appBlockLetters
          >
          <span class="form-text text-danger" *ngIf="isValidArray(i, 'tonnage') && !location.errors?.tonnageExceeds">
            Ingresa un tonelaje positivo y con máximo tres decimales
          </span>
          <span class="form-text text-danger" *ngIf="location.errors?.tonnageExceeds">
            El tonelaje debe ser menor o igual al de la ubicación
          </span>
        </div>
        <div class="d-flex">
          <div class="w-100">
            <label for="piecesPerYard-{{ i }}" class="form-label">{{ texts.piecesLabel }}</label>
            <input
              type="text"
              id="piecesPerYard-{{ i }}"
              class="form-control"
              formControlName="pieces"
              appOnlyNumbers
              [maxDigits]="10"
            >
            <span class="form-text text-danger" *ngIf="isValidArray(i, 'pieces') && !location.errors?.piecesExceeds">
              Ingrese el numero de piezas
            </span>
            <span class="form-text text-danger" *ngIf="location.errors?.piecesExceeds">
              El número de piezas debe ser menor o igual al de la ubicación
            </span>
          </div>
          <i class="bi bi-trash3 ms-3 patios-size" *ngIf="movimiento !== 'detalle'" (click)="deleteLocation(i)"></i>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
  *ngIf="overlay"
  [mensaje]="message"
  [icono]="icon"
></app-overlay>
